/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneProse as ResolvedStandaloneProse } from 'base/components/standalone/Prose';

export const Prose: typeof ResolvedStandaloneProse = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneProse {...props} />
        </ErrorBoundary>
    );
});

export type ProseProps = PropsFromComponent<typeof Prose>;

/** @deprecated Use slot architecture instead */
export const ProseWith = (extras: DynamicStandaloneExtras): typeof Prose => {
    return function Prose(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Prose');
        return <ResolvedStandaloneProse {...mergeProps({ options: { theme } }, props)} />;
    }
}